// extracted by mini-css-extract-plugin
export default {"Blur":"Briefs_Blur__JIhKB","Blurrier":"Briefs_Blurrier__h29Cx"};